import Api from '../service/Api';

export default {
  newplanoAula: planoAula => Api.post('planoAulas', planoAula),
};
